import React from "react"
import '../css/spinner.css'

export default function Spinner(){
return(
    <div class="hungry-4"></div>
)
}